import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Ideation",
    description: "Conducting Product Discovery and Product Research",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description: "Creating the UX Design, UI Design, and Branding",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Development",
    description: "Coding the web courtesy of our veteran engineers",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Quality Assurance",
    description: "Testing the web and making sure that everything works well",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Deployment",
    description:
      "Launching the web smoothly with expert rollout strategies and support.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Maintenance & Support",
    description: "Co-managing the web with your technology team.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2>
              TekRevol’s Proficient Steps to{" "}
              <span>Web Design and Development</span>
              Supremacy
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              Our steps to ensure an ideal web design and development process
              are aligned systematically to gain the optimal result. Utilising
              the expertise of our web designer and developers in the UK, we
              carry out each phase in an efficient manner.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div
                className="workflow_items"
                style={{ background: "#F9F9F9", pointerEvents: "none" }}
              >
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
